import { Stack } from 'components/Stack';
import styled from 'styled-components';
import {
  Thumbnail as ThumbnailCommon,
  TruncatedTitle,
} from '../../ItemCommons';

const DetailedWrapper = styled(Stack).attrs({
  justify: 'space-between',
  direction: 'column',
})`
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 8px;
  padding-bottom: 16px;
  height: 100%;
`;

const Thumbnail = styled(ThumbnailCommon)`
  flex-shrink: 0;
`;

const QuantityPriceWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TruncatedDetailTitle = styled(TruncatedTitle)`
  height: 36px;
`;

export {
  DetailedWrapper,
  Thumbnail,
  QuantityPriceWrapper,
  TruncatedDetailTitle,
};
